import Skeleton from "react-loading-skeleton";
import {TBreadcrumb} from "@/app/models/wp";
import React from "react";

interface IProps {
    breadcrumb: TBreadcrumb;
}

export default function Breadcrumb({breadcrumb}: IProps) {
    if (!breadcrumb || typeof breadcrumb !== "object") {
        return
    }

    const breadcrumbSchema = breadcrumb.map((crumb, index) => {
        const isLastItem = index === breadcrumb.length - 1;

        return {
            "@type": "ListItem",
            "position": index + 1,
            "name": crumb.text,
            ...(isLastItem ? {} : { "item": crumb.url })
        };
    });

    const schema = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": breadcrumbSchema,
    }

    return (
        <>
            <nav
                aria-label="breadcrumb"
                id="breadcrumb"
                className="flex overflow-x-auto overflow-hidden pb-6 flex-row-reverse md:flex-row scrollbar-none lg:max-w-screen-lg+ w-full px-2 md:px-0"
            >
                <ul className="flex">
                    {breadcrumb?.map((crumb: { url: string | undefined; text: string | undefined }, index: number) => (
                        <li
                            key={index}
                            className="whitespace-nowrap md:inline font-light text-rm-12 pr-1 text-black"
                        >
                            {index !== breadcrumb.length - 1 ? (
                                <>
                                    <a
                                        className="pr-1 underline"
                                        href={crumb.url}
                                    >
                                        {crumb.text}
                                    </a>

                                    {' > '}
                                </>
                            ) : (
                                crumb.text
                            )}
                        </li>
                    ))}
                </ul>
            </nav>

            <script
                id="QAHomepageSchemaScript"
                type="application/ld+json"
                dangerouslySetInnerHTML={{__html: JSON.stringify(schema) ?? ''}}
            />
        </>
    )
}

export function BreadcrumbSkeleton() {
    return (
        <>
            <div className="flex gap-4">
                <Skeleton
                    containerClassName="h-5 flex opacity-50 w-3/12 md:w-1/12"
                />
                <Skeleton
                    containerClassName="h-5 flex opacity-50 w-4/12 md:w-1/12"
                />
                <Skeleton
                    containerClassName="h-5 flex opacity-50 w-3/12 md:w-1/12"
                />
            </div>
        </>
    )
}
